import React, { useState } from 'react'
import './Search.css'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css';

import { DateRangePicker } from 'react-date-range';
import { People } from '@material-ui/icons';
import { Button } from '@material-ui/core';

import { useHistory } from 'react-router-dom'

//Date Picker with Search
function Search() {

    const history = useHistory()

    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())

    const selectionRange = {
        startDate,
        endDate,
        key: 'selection'
    }

    const handleSelect = (ranges) => {
        setStartDate(ranges.selection.startDate)
        setEndDate(ranges.selection.endDate)
    }

    return (
        <div className='search'>
            <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />

            <div className="search__utils">
                <h2>
                    Number of guests
                    <People />
                </h2>

                <input min={0} defaultValue={2} type="number"/>

                <Button onClick={() => history.push('/search')}>Search Airbnb</Button>
            </div>
            
        </div>
    )
}

export default Search
